import getLocalStorage from 'src/helpers/getLocalStorage'
import { useMemo, useEffect, useSelector, usePersistedUserData } from '.'

type QuerySponsor = {
  genealogyId: string
}

const sponsor_key = 'sponsor'

export const persistSponsorData = (genealogyId: string) => {
  const storage = getLocalStorage()
  if (!storage) {
    return
  }

  const newPersisted: QuerySponsor = {
    genealogyId,
  }

  storage.setItem(sponsor_key, JSON.stringify(newPersisted))
}

const useQuerySponsor = (): QuerySponsor | undefined => {
  const { account } = usePersistedUserData()
  const sponsorArg = useSelector(state => state.route.args.sponsor)

  // Save to local storage
  useEffect(() => {
    if (sponsorArg === undefined) {
      return
    }
    persistSponsorData(sponsorArg)
  })

  const querySponsor = useMemo(() => {
    if (sponsorArg !== undefined) {
      return {
        genealogyId: sponsorArg,
      }
    }
    const storage = getLocalStorage()
    const possibleValue = storage?.getItem(sponsor_key) ?? undefined
    if (possibleValue !== undefined) {
      return JSON.parse(possibleValue)
    }

    return undefined
  }, [sponsorArg])

  return account && account.username
    ? undefined // Joined users are asked to choose a sponsor by the ProgressiveProfileActions if they do not have one
    : querySponsor
}

export default useQuerySponsor
